package sarka.design.skoria.ui

import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.size
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.material3.Surface
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import org.jetbrains.compose.resources.painterResource
import sarka.design.skoria.presentation.VerifyEmailUiState
import sarka.design.skoria.ui.composables.SkoriaPrimaryButton
import sarka.design.skoria.ui.composables.SkoriaSecondaryButton
import sarka.design.skoria.ui.composables.SkoriaTextField
import sarka.design.skoria.ui.theme.RCTheme
import skoria.composeapp.generated.resources.Res
import skoria.composeapp.generated.resources.skoria_logo

@Composable
fun VerifyEmailScreen(
    state: VerifyEmailUiState,
    onCodeChange: (String) -> Unit,
    onVerify: () -> Unit,
    onResendCode: () -> Unit,
    onVerificationSuccess: () -> Unit
) {
    LaunchedEffect(state.verificationSuccess) {
        if (state.verificationSuccess) {
            onVerificationSuccess()
        }
    }

    Surface {
        Column(
            modifier = Modifier.fillMaxSize(),
            verticalArrangement = Arrangement.Center,
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            Image(
                painter = painterResource(Res.drawable.skoria_logo),
                contentDescription = "Skoria Logo",
                modifier = Modifier.size(100.dp)
            )

            Spacer(modifier = Modifier.height(16.dp))

            Text(
                text = "Verify Your Email",
                color = RCTheme.colors.primary,
                fontSize = 28.sp
            )

            Spacer(modifier = Modifier.height(16.dp))

            Text(
                text = "We've sent a 6-digit code to",
                color = RCTheme.colors.primary,
                fontSize = 14.sp,
                textAlign = TextAlign.Center
            )
            
            Text(
                text = state.email,
                color = RCTheme.colors.primary,
                fontSize = 14.sp,
                textAlign = TextAlign.Center
            )

            Spacer(modifier = Modifier.height(24.dp))

            SkoriaTextField(
                hint = "Enter 6-digit code",
                value = state.code,
                onValueChange = onCodeChange,
                enabled = !state.isLoading
            )

            if (state.error != null) {
                Spacer(modifier = Modifier.height(8.dp))
                Text(
                    text = state.error,
                    color = RCTheme.colors.error,
                    fontSize = 14.sp
                )
            }

            if (state.resendMessage != null) {
                Spacer(modifier = Modifier.height(8.dp))
                Text(
                    text = state.resendMessage,
                    color = RCTheme.colors.primary,
                    fontSize = 14.sp
                )
            }

            Spacer(modifier = Modifier.height(24.dp))

            if (state.isLoading) {
                CircularProgressIndicator()
            } else {
                SkoriaPrimaryButton(
                    text = "Verify",
                    onClick = onVerify
                )

                Spacer(modifier = Modifier.height(16.dp))

                SkoriaSecondaryButton(
                    text = "Resend Code",
                    onClick = onResendCode
                )
            }
        }
    }
}
